import type { Opportunity } from "@/types/opportunity";

export type OpportunityListSummary = {
  total_sale_price: number | null;
  deposit_amount: number | null;
  location_name: string | null;
  assigned_user_name: string | null;
  generated_by_name: string | null;
};

export type OpportunityListItem = Opportunity & {
  list_summary?: OpportunityListSummary;
};

export const OPPORTUNITY_LIST_PAGE_SIZES = [5, 10, 25] as const;
export type OpportunityListPageSize = (typeof OPPORTUNITY_LIST_PAGE_SIZES)[number];

export type OpportunityListSortKey = "updated" | "user" | "location";
export type OpportunityListSortDir = "asc" | "desc";

export const OPPORTUNITY_LIST_DEFAULT_PAGE_SIZE: OpportunityListPageSize = 5;
export const OPPORTUNITY_LIST_DEFAULT_SORT_KEY: OpportunityListSortKey = "updated";
export const OPPORTUNITY_LIST_DEFAULT_SORT_DIR: OpportunityListSortDir = "desc";
